export default __webpack_public_path__ + "static/media/x33-logo-wc.d0d10471.png";